import {
  SET_PICKUP_ADDRESS,
  SET_SUGGESTADDRESS,
  UPDATE_PICKUPADDRESS,
  SET_ADDRESS_ERRORS,
  COPY_GEOSUGGEST_ADDRESS,
  CHECK_ADDRESS_EDIT_FLAG
} from "../actions/address";

const INITIAL_STATE = {
  pickupAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  geoSuggestAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    isPartialMatch: false
  },
  errors: {},
  addressEditFlag: false
};

export const addressReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PICKUP_ADDRESS:
      return {
        ...state,
        pickupAddress: { ...state.pickupAddress, ...action.payload }
      };

    case CHECK_ADDRESS_EDIT_FLAG:
      return {
        ...state,
        addressEditFlag: true
      };

    case SET_SUGGESTADDRESS:
      return {
        ...state,
        geoSuggestAddress: { ...state.geoSuggestAddress, ...action.payload }
      };

    case UPDATE_PICKUPADDRESS:
      return {
        ...state,
        pickupAddress: { ...state.pickupAddress, ...action.payload }
      };

    case SET_ADDRESS_ERRORS:
      return {
        ...state,
        errors: { ...state.errors, ...action.payload }
      };

    case COPY_GEOSUGGEST_ADDRESS:
      return {
        ...state,
        pickupAddress: { ...state.geoSuggestAddress, ...action.payload },
        geoSuggestAddress: { ...state.geoSuggestAddress, isPartialMatch: false }
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/address.js